import Header from "./Header";
import Footer from "./Footer";
import ProductEventsBlock from "@/themes/printerwebshop/ProductEventsBlock";

export default function PrinterwebshopTheme({ children, hideHeader, hideFooter, enableMoreProducts, products }) {
  return (
    <div>
      {!hideHeader && <Header />}
      <main className="">
        {children}
      </main>
      {enableMoreProducts && (
        <ProductEventsBlock products={products} />
      )}
      {!hideFooter && <Footer />}
    </div>
  );
}